(function () {
  'use strict';

  var OPEN_CLASS = 'is-open';
  var isPanelOpen = false;
  var isLoading = false;
  var PRESERVED_PARAMS = ['sort_by', 'q', 'options[prefix]', 'type'];

  /*
    What the visitor has done inside the panel that the server's HTML knows nothing about: which
    groups are open (by their handle-based checkbox id), which lists show all their values, what is
    typed into a value search, and how far the list is scrolled.

    A tick re-renders the panel twice — this file's own fetch (updateFiltersDrawer) and the theme's
    renderer through `ajaxCollection:render`, which replaces the whole #MobileFiltersDrawer a moment
    later (it announces itself with `collection:reloaded`). Kept up to date by the listeners below
    rather than read off the DOM before a replace, because the second render has no "before" hook —
    and is restored after both.
  */
  var panelState = emptyState();

  function emptyState() {
    return { open: {}, showAll: {}, queries: {}, scroll: 0 };
  }

  function groupId(node) {
    var wrapper = node.closest('.ais-facet-dropdown-wrapper');
    var toggle = wrapper && wrapper.querySelector('.ais-dropdown-checkbox');
    return toggle ? toggle.id : null;
  }

  function mainWrapper() {
    return document.querySelector('#MobileFiltersDrawer .ais-facets-main-wrapper');
  }

  function restoreState() {
    var drawer = document.getElementById('MobileFiltersDrawer');
    if (!drawer) return;

    Object.keys(panelState.open).forEach(function (id) {
      var toggle = document.getElementById(id);
      if (toggle && drawer.contains(toggle)) toggle.checked = true;
    });

    drawer.querySelectorAll('.ais-RefinementList-showMore').forEach(function (button) {
      if (panelState.showAll[groupId(button)]) setShowAll(button, true);
    });

    drawer.querySelectorAll('[data-filter-search]').forEach(function (input) {
      var query = panelState.queries[groupId(input)];
      if (query) {
        input.value = query;
        filterValues(input);
      }
    });

    var scroller = mainWrapper();
    if (scroller) scroller.scrollTop = panelState.scroll;
  }

  // ── show more / value search ──────────────────────────────────────────────

  function setShowAll(button, showAll) {
    var wrapper = button.closest('.ais-facet-dropdown-wrapper');
    wrapper.classList.toggle('is-showing-all', showAll);
    button.textContent = showAll ? button.dataset.showLess : button.dataset.showMore;
    button.setAttribute('aria-expanded', showAll ? 'true' : 'false');
  }

  // Matches anywhere in the value's label, ignoring case. While a query is typed the folded values
  // take part too, so the search covers the whole list rather than the first few.
  function filterValues(input) {
    var wrapper = input.closest('.ais-facet-dropdown-wrapper');
    var query = input.value.trim().toLowerCase();
    wrapper.classList.toggle('is-searching', query !== '');
    wrapper.querySelectorAll('.ais-facet--item').forEach(function (item) {
      var text = item.querySelector('.ais-RefinementList-labelText');
      var label = (text ? text.textContent : item.textContent).toLowerCase();
      item.hidden = query !== '' && label.indexOf(query) === -1;
    });
  }

  // ── params / AJAX helpers ──────────────────────────────────────────────────

  function buildSearchParams(form) {
    var current = new URLSearchParams(window.location.search);
    var next = new URLSearchParams();
    PRESERVED_PARAMS.forEach(function (key) {
      if (current.has(key)) next.set(key, current.get(key));
    });
    form.querySelectorAll('input.ais-RefinementList-checkbox:checked').forEach(function (input) {
      next.append(input.name, input.value);
    });
    form.querySelectorAll('input[name^="filter.v.price"]').forEach(function (input) {
      if (input.value) next.set(input.name, input.value);
    });
    return next;
  }

  // Exposed so theme.js can call it after its own AJAX replace (e.g. active-filter removal links).
  // Pass preserveOpen=false so the drawer resets to its closed groups — the user acted from outside
  // the drawer.
  window._mobileFiltersUpdateDrawer = function(doc) { updateFiltersDrawer(doc, false); };

  function updateFiltersDrawer(doc, preserveOpen) {
    var newDrawer = doc.getElementById('MobileFiltersDrawer');
    var curDrawer = document.getElementById('MobileFiltersDrawer');
    if (!newDrawer || !curDrawer) return;

    var newForm = newDrawer.querySelector('#MobileFiltersForm');
    var curForm = curDrawer.querySelector('#MobileFiltersForm');
    if (newForm && curForm) curForm.innerHTML = newForm.innerHTML;

    if (preserveOpen === false) panelState = emptyState();
    restoreState();
  }

  function applyFilters(form) {
    if (isLoading) return;
    var sectionEl = document.querySelector('[data-collection-template]');
    if (!sectionEl) return;
    var sectionId = sectionEl.getAttribute('data-section-id');
    var params = buildSearchParams(form);
    var paramsStr = params.toString();

    history.pushState({}, '', window.location.pathname + (paramsStr ? '?' + paramsStr : ''));

    isLoading = true;
    var content = document.getElementById('CollectionAjaxContent');
    if (content) content.classList.add('is-loading');
    form.classList.add('is-loading');

    fetch(window.location.pathname + '?section_id=' + sectionId + (paramsStr ? '&' + paramsStr : ''))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContent = doc.getElementById('CollectionAjaxContent');
        var curContent = document.getElementById('CollectionAjaxContent');
        if (newContent && curContent) {
          curContent.innerHTML = newContent.innerHTML;
          curContent.classList.remove('is-loading');
        }
        updateFiltersDrawer(doc);
        form.classList.remove('is-loading');
        isLoading = false;

        if (window.theme) {
          theme.sections.reinit('collection-template');
          if (window.theme.reinitProductGridItem) theme.reinitProductGridItem();
        }

        // Re-override the open button (theme may have re-wired it)
        bindOpenButton();

        document.dispatchEvent(new CustomEvent('collection:reloaded', { detail: { toggleFilters: false, source: 'mobileFilters' } }));
      })
      .catch(function () {
        isLoading = false;
        var content = document.getElementById('CollectionAjaxContent');
        if (content) content.classList.remove('is-loading');
        form.classList.remove('is-loading');
      });
  }

  // Reloads the grid for the form's current state, and tells the theme's renderer (the mobile
  // active-filter tags) about it.
  function refresh(form) {
    applyFilters(form);

    document.dispatchEvent(new Event('filter:selected', { bubbles: true }));

    var params = buildSearchParams(form);
    var newUrl = new URL(window.location.pathname + '?' + params.toString(), window.location.origin);
    document.dispatchEvent(
      new CustomEvent('ajaxCollection:render', {
        detail: { newUrl: newUrl },
        bubbles: true
      })
    );
  }

  // ── panel open / close ────────────────────────────────────────────────────

  function openPanel() {
    var panel = document.getElementById('MobileFiltersDrawer');
    if (!panel) return;
    isPanelOpen = true;
    panel.classList.add(OPEN_CLASS);
    document.body.classList.add('mobile-filters-open');
  }

  // Closing forgets the open groups, so the panel opens fresh next time — on the server's HTML,
  // which is what restoring nothing leaves.
  function closePanel() {
    var panel = document.getElementById('MobileFiltersDrawer');
    if (!panel) return;
    isPanelOpen = false;
    panelState = emptyState();
    panel.classList.remove(OPEN_CLASS);
    document.body.classList.remove('mobile-filters-open');
    panel.querySelectorAll('.ais-dropdown-checkbox:checked').forEach(function (toggle) {
      toggle.checked = false;
    });
  }

  // ── ONE-TIME document-level listeners ─────────────────────────────────────
  // These are added once and never need rebinding — they work on the live DOM
  // at the moment of each click/change, regardless of innerHTML replacements.

  document.addEventListener('click', function (evt) {
    var panel = document.getElementById('MobileFiltersDrawer');

    // Open button (outside panel) — capture phase fires before theme's element handler.
    // stopPropagation prevents the event from reaching the button so theme never runs.
    if (evt.target.closest('.collection-filter__btn')) {
      evt.stopPropagation();
      if (panel) panel.classList.contains(OPEN_CLASS) ? closePanel() : openPanel();
      return;
    }

    if (!panel || !panel.contains(evt.target)) return;

    if (evt.target.closest('.ais-facets-header__close')) {
      closePanel();
      return;
    }

    var showMore = evt.target.closest('.ais-RefinementList-showMore');
    if (showMore) {
      var showAll = !showMore.closest('.ais-facet-dropdown-wrapper').classList.contains('is-showing-all');
      setShowAll(showMore, showAll);
      panelState.showAll[groupId(showMore)] = showAll;
      return;
    }

    // Clear → untick everything and reload in place; the panel stays open on the groups the visitor
    // had open, as after a single tick.
    if (evt.target.closest('.ais-facet-mobile__reset-btn')) {
      var form = document.getElementById('MobileFiltersForm');
      form.querySelectorAll('input.ais-RefinementList-checkbox:checked').forEach(function (input) {
        input.checked = false;
      });
      form.querySelectorAll('input[name^="filter.v.price"]').forEach(function (input) {
        input.value = '';
      });
      refresh(form);
      return;
    }

    // Apply → the grid is already up to date (every tick reloads it), so this only closes the panel.
    if (evt.target.closest('.ais-facet-mobile__apply-btn')) {
      evt.preventDefault();
      closePanel();
      return;
    }

    // backdrop (clicking the panel overlay itself) → close
    if (evt.target === panel) closePanel();
  }, true); // capture phase — fires before any direct element handlers

  document.addEventListener('change', function (evt) {
    var form = document.getElementById('MobileFiltersForm');
    if (!form || !form.contains(evt.target)) return;

    if (evt.target.classList.contains('ais-dropdown-checkbox')) {
      if (evt.target.checked) panelState.open[evt.target.id] = true;
      else delete panelState.open[evt.target.id];
      return;
    }
    if (evt.target.hasAttribute('data-filter-search')) return;

    refresh(form);
  });

  document.addEventListener('input', function (evt) {
    if (!evt.target.matches || !evt.target.matches('#MobileFiltersDrawer [data-filter-search]')) return;
    filterValues(evt.target);
    panelState.queries[groupId(evt.target)] = evt.target.value;
  });

  // Enter in a value search would submit the form, which the apply button's handler reads as
  // "close the panel".
  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Enter' && evt.target.matches && evt.target.matches('#MobileFiltersDrawer [data-filter-search]')) {
      evt.preventDefault();
    }
  });

  // Scroll doesn't bubble, but it does run the capture phase — so one listener survives every
  // replace of the list.
  document.addEventListener('scroll', function (evt) {
    if (evt.target === mainWrapper()) panelState.scroll = evt.target.scrollTop;
  }, true);

  // ── open button (theme jQuery/Zepto API) ──────────────────────────────────

  function bindOpenButton() {
    var panel = document.getElementById('MobileFiltersDrawer');
    var btn   = document.querySelector('.collection-filter__btn');
    if (!panel || !btn) return;
    try {
      btn.off('click');
      btn.on('click', function () {
        panel.classList.contains(OPEN_CLASS) ? closePanel() : openPanel();
      });
    } catch (e) {
      btn.onclick = function () {
        panel.classList.contains(OPEN_CLASS) ? closePanel() : openPanel();
      };
    }
  }

  // ── init ──────────────────────────────────────────────────────────────────

  function initMobileFilters() {
    bindOpenButton();
    var panel = document.getElementById('MobileFiltersDrawer');
    if (panel && isPanelOpen) {
      panel.classList.add(OPEN_CLASS);
      restoreState();
    }
  }

  document.addEventListener('collection:reloaded', function (evt) {
    var detail = evt.detail || {};
    if (detail.source === 'mobileFilters') return;
    initMobileFilters();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileFilters);
  } else {
    initMobileFilters();
  }
})();
